import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import {AppSettingsService} from "./app-settings.service";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {NG_VALUE_ACCESSOR, SelectControlValueAccessor} from "@angular/forms";
import {createEvent} from "../misc/event.polyfill";
import {Subscription} from "rxjs/Subscription";
import {ContactLocaleModel} from "../types/contact-locale";

export function makeContactLocaleSelectorComponentProvider() {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectContactLocaleComponent),
    multi: true,
  };
}

@Component({
  selector: "select-contact-locale",
  templateUrl: "./contact-locale-selector.template.pug",
  providers: [makeContactLocaleSelectorComponentProvider()],
})
@exposeComponentInDebugMode({multi: true})
export class SelectContactLocaleComponent extends SelectControlValueAccessor implements OnInit, OnDestroy {
  private _value: string;
  private subscription: Subscription;
  contactLocales: ContactLocaleModel[] = [];

  @Output("onChange")
  public onChangeEmitter: any = new EventEmitter();

  @Input()
  blank: boolean;

  @Input()
  inputId: string;

  @Input()
  inputName: string;

  @Input()
  disabled: boolean;

  @Input()
  error: Error;

  private emitOnChange(obj: string, oldObj: string): void {
    const event = createEvent("change");
    event["value"] = obj;
    event["oldValue"] = oldObj;
    this.onChangeEmitter.emit(event);
  }

  onChange = (_) => {}; // eslint-disable-line
  onTouched = () => {};

  get value(): string {
    return this._value;
  }

  set value(obj: string) {
    const oldObj = this._value;
    this._value = obj;

    this.onChange(obj);
    this.emitOnChange(obj, oldObj);
  }

  writeValue(obj: string) {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  constructor(
    private appSettingsService: AppSettingsService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    super(renderer, elementRef);
  }

  ngOnInit() {
    this.subscription = this.appSettingsService.contactLocales.subscribe((contactLocales) => {
      this.contactLocales = contactLocales;
    });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }
  }
}
